import { render, staticRenderFns } from "./KISoftwareentwicklung.vue?vue&type=template&id=7bfa5efe&"
import script from "./KISoftwareentwicklung.vue?vue&type=script&lang=js&"
export * from "./KISoftwareentwicklung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports